import { createContext } from "react";

// Definizione delle opzioni configurabili per ogni conferma
export interface ConfirmOptions {
  title?: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: "danger" | "info"; // Per stili diversi (es. bottone rosso per cancellare)
}

export interface ConfirmContextType {
  confirm: (options?: ConfirmOptions) => Promise<boolean>;
}

export const ConfirmContext = createContext<ConfirmContextType | undefined>(undefined);

